module.exports = __webpack_public_path__ + "static/mapmarker-75eabe73a290c863d70bc8885620dbd2.png";